module.exports = __webpack_public_path__ + "icon-usergroup.a98d8c223eda63245cf3.png";